import {Injectable} from "@angular/core";
import {ToastComponent} from "@app/presentation/services/toast/toast.component";
import {ToastrService} from 'ngx-toastr';
import {DisplayService} from "@app/presentation/services/display.service";
import {firstValueFrom} from "rxjs";

@Injectable()
export class ToastService {

    constructor(
        private displayService: DisplayService,
        private toastService: ToastrService,
    ) { }

    async show(message: string, onClickAction?: (() => void) | null) {
        const isMobile = await firstValueFrom(this.displayService.isMobileDisplay$);

        const toast = this.toastService.show(message, "", {
            toastComponent: ToastComponent,
            positionClass: isMobile ? "toast-top-center" : "toast-bottom-center",
            timeOut: 4000,
            tapToDismiss: false,
            easeTime: 200,
        });
        toast.toastRef.componentInstance._onClickAction = onClickAction;
    }
}
